export default function (cli) {
  return {
    list () {
      return cli.get(`${cli.apiEndpoint}shops/`)
    },
    get (shopPk) {
      return cli.get(`${cli.apiEndpoint}shops/${shopPk}/`)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/shop.js